<template>
  <div id="app">
    <tanitimMail ref="tanitimdialog" :servisTipi="3"></tanitimMail>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp
      v-bind:mesaj="text1"
      v-model="snackbar"
      v-bind:color="snackbarkColor"
    ></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t("Search-Flight") }} </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-flex>

        <!-- Arama  Filtre Gun DEgistirme -->
        <ucusara
          @showList="showTickets($event)"
          @filterList="filterTicketList($event)"
          @setFlightType="setFlightType($event)"
        ></ucusara>

        <!-- bilet listesi -->
        <ucuslist
          :ticketList="ticketList"
          :FlightType="FlightType"
          :isActive="ActiveType"
        ></ucuslist>

        <v-flex v-if="0 >= ticketList.length" class="justify-center" pa-2>
          <v-card>
            <v-card-title primary-title>
              <blockquote class="blockquote">
                   {{ $t('runner-v8') }}
                  <v-btn
                    color="blue-grey"
                    class="white--text"
                    @click="irtibatDialog()"
                  >
                    {{ $t('CONTACT-US') }}
                    <v-icon right dark>contact_mail</v-icon>
                  </v-btn>
                </blockquote>
            </v-card-title>
        
          <img src="../../../../assets/images/aer.png" class="responsive"/>
          </v-card>
         
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import ucusara from "../comp/ucak/ucusara.vue";
import ucuslist from "../comp/ucak/ucuslist.vue";
import auth from "@/api/auth.js";
import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  data() {
    return {
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        },
      ],
      ticketList: [],
      filterBackupTicketList: [],
      snackbarkColor: "black",
      number: 1,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      FlightType: null,
      ActiveType: null,
      ucuAraPrms:{
        SessionHeader: {
    SessionId: "M8YdiSXb2uwuzwo",
    SessionToken: "b0c67d31-79f0-4d05-a028-48a53c934ec4"
  },
  AirSearchOptions: {
    FlightType: "OW",
    CabinType: "Economy",
    RefundableType: "AllFlights",
    Currency: "TRY",
    DirectFlightsOnly: false,
    AvailableFlightsOnly: true,
    FareDisplayType: "Lowest"
  },
  AirSearchPaxItems: [
    {
      "PaxCode": "ADT",
      "PaxCount": 1
    }
  ],
  AirSearchSegments: [
    {
      SequenceNo: 1,
      DepartureDay: "2024.06.21",
      Origin: {
        AirportCode: "IST",
        IsCity: false
      },
      Destination: {
        AirportCode: "AYT",
        IsCity: false
      }
    }
  ]


      }
    };
  },
  methods: {
    ucusarav2()
    {
      
      this.$http
        .post("http://localhost:1538/Air/Search", this.ucuAraPrms, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
           console.log(response);
         
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    login()
    {
      var params = {
        Username: "Arkgsa",
  Password: "3paPVcsbbpf5Lwj",
  IsTest: true

      };

      this.$http
        .post( 'https://testbookingapi.arkman.com.tr/' + "Login", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
          
           this.ucuAraPrms.SessionHeader.SessionId=response.body.SessionId;
           this.ucuAraPrms.SessionHeader.SessionToken=response.body.SessionToken;
           
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    irtibatDialog() {
      this.$refs.tanitimdialog.open(0);
    },
    getAccountDetails() {
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CustomerID: credentials.MusteriID,
        ServiceID: 1
      };

      this.$http
        .post(auth.API_URL + "api/Booking/ServiceInfoLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            auth.BOOKING_API_URL   = 'https://testbookingapi.arkman.com.tr/';//response.body.Url;
            this.ActiveType = response.body.Active;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    setFlightType(value) {
      this.FlightType = value;
    },
    filterTicketList(value) {
      //1 : fiyat - 2 : saat Departure - 3: saat Arrival - 4 : direct fly - 5 : transfer fly 6: Airline 7: flex 8 : promo
      switch (value.type) {
        case 1:
          var euroPrice = (value.ticketPrice / value.currency) * 1;
          this.ticketList = this.filterBackupTicketList.filter(
            (element) => euroPrice > element.TotalFare
          );
          break;
        case 2:
          var timeDepartureStart = value.timeDepartureRange[0];
          var timeDepartureEnd = value.timeDepartureRange[1];
          if (timeDepartureStart > 9) {
            timeDepartureStart = timeDepartureStart + ":00";
          } else {
            timeDepartureEnd = "0" + timeDepartureEnd + ":00";
          }
          if (timeDepartureEnd > 9) {
            timeDepartureEnd = timeDepartureEnd + ":00";
          } else {
            timeDepartureEnd = "0" + timeDepartureEnd + ":00";
          }
          this.ticketList = [];
          for (
            let index = 0;
            index < this.filterBackupTicketList.length;
            index++
          ) {
            const element = this.filterBackupTicketList[index];

            for (let i = 0; i < element.FlightSegments.length; i++) {
              const item = element.FlightSegments[i];

              if (
                item.DepartureTime >= timeDepartureEnd &&
                item.DepartureTime <= timeDepartureEnd
              ) {
                this.ticketList.push(element);
              }
            }
          }
          break;
        // eslint-disable-next-line no-duplicate-case
        case 3:
          var timeDestinationStart = value.timeDestinationRange[0];
          var timeDestinationEnd = value.timeDestinationRange[1];
          if (timeDestinationStart > 9) {
            timeDestinationStart = timeDestinationStart + ":00";
          } else {
            timeDestinationStart = "0" + timeDestinationStart + ":00";
          }
          if (timeDestinationEnd > 9) {
            timeDestinationEnd = timeDestinationEnd + ":00";
          } else {
            timeDestinationEnd = "0" + timeDestinationEnd + ":00";
          }
          this.ticketList = [];
          for (
            let index = 0;
            index < this.filterBackupTicketList.length;
            index++
          ) {
            const element = this.filterBackupTicketList[index];

            for (let i = 0; i < element.FlightSegments.length; i++) {
              const item = element.FlightSegments[i];

              if (
                item.ArrivalTime >= timeDestinationStart &&
                item.ArrivalTime <= timeDestinationEnd
              ) {
                this.ticketList.push(element);
              }
            }
          }
          break;
        case 4:
          //FlightSegments.IsConnected == true aktarma var
          if (value.direct) {
            this.ticketList = [];
            for (
              let index = 0;
              index < this.filterBackupTicketList.length;
              index++
            ) {
              const element = this.filterBackupTicketList[index];

              for (let i = 0; i < element.FlightSegments.length; i++) {
                const item = element.FlightSegments[i];

                if (item.IsConnected == false) {
                  this.ticketList.push(element);
                }
              }
            }
          } else {
            this.ticketList = [];
            for (
              let index = 0;
              index < this.filterBackupTicketList.length;
              index++
            ) {
              const element = this.filterBackupTicketList[index];

              for (let i = 0; i < element.FlightSegments.length; i++) {
                const item = element.FlightSegments[i];

                if (item.IsConnected == true) {
                  this.ticketList.push(element);
                }
              }
            }
          }
          break;
        case 5:
          if (value.transfer && !value.direct) {
            this.ticketList = [];
            for (
              let index = 0;
              index < this.filterBackupTicketList.length;
              index++
            ) {
              const element = this.filterBackupTicketList[index];

              for (let i = 0; i < element.FlightSegments.length; i++) {
                const item = element.FlightSegments[i];

                if (item.IsConnected == true) {
                  this.ticketList.push(element);
                }
              }
            }
          } else {
            this.ticketList = [];
            for (
              let index = 0;
              index < this.filterBackupTicketList.length;
              index++
            ) {
              const element = this.filterBackupTicketList[index];

              for (let i = 0; i < element.FlightSegments.length; i++) {
                const item = element.FlightSegments[i];

                if (item.IsConnected == false) {
                  this.ticketList.push(element);
                }
              }
            }
          }
          break;
        case 6:
          var newTicketList = [];
          var LastTicketList = [];
          var controlList = 0;
          value.airline.forEach((element) => {
            if (element.value == true) {
              let result = this.filterBackupTicketList.filter((filterElement) =>
                filterElement.FlightSegments.find(
                  (data) => data.MarkettingAirline === element.code
                )
              );
              if (controlList == 0) {
                LastTicketList = newTicketList.concat(result);
              } else {
                LastTicketList = LastTicketList.concat(result);
              }
            }
            controlList = 2;
          });

          this.ticketList = LastTicketList;

          break;
        case 7:
          if (value.flex == true) {
            let filterItem = this.filterBackupTicketList.filter(
              (element) => element.PricingInfo.FareInfoType == "Flex"
            );
            this.ticketList = filterItem;
          } else {
            let filterItem = this.filterBackupTicketList.filter(
              (element) => element.PricingInfo.FareInfoType != "Flex"
            );
            this.ticketList = filterItem;
          }
          break;
        case 8:
          if (value.promo == true) {
            let filterItem = this.filterBackupTicketList.filter(
              (element) => element.PricingInfo.FareInfoType == "Promo"
            );
            this.ticketList = filterItem;
          } else {
            let filterItem = this.filterBackupTicketList.filter(
              (element) => element.PricingInfo.FareInfoType != "Promo"
            );
            this.ticketList = filterItem;
          }
          break;
        default:
          break;
      }
    },
    showTickets(value) {
      this.ticketList = value;
      this.filterBackupTicketList = value;
    },

    getToken() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CustomerID: credentials.MusteriID,
        ServiceID: 1,
      };

      this.$http
        .post(auth.API_URL + "api/Booking/Login", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            window.localStorage.setItem(
              "bookingParams",
              JSON.stringify(response.body)
            );
            this.ActiveType = response.body.Active;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-BookingLogin";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-BookingLogin";
              this.snackbar = true;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    ucusara,
    ucuslist,
    tanitimMail
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      //YETKİ OK
      this.login();
      this.getAccountDetails();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};
</script>

<style scoped>
.rounded-corner {
  border-start-start-radius: 20px;
  border-end-end-radius: 20px;
}
.responsive {
  max-width: 100%;
  height: auto;
}
</style>

